export const TRANSFERRING_BANK_TO_DO = {
  title: 'transferringBankToDo',
  subtitle: 'transferringBankToDoSubTitle',
  descriptionHeaderKey: 'transferringBankToDoDescriptionHeader',
  descriptionBodyKey: 'transferringBankToDoDescriptionBody',
  fieldDefinitions: [
    {
      type: 'select-many',
      name: 'refuseDebitsAndDepositsPartnerToggle',
      options: {
        type: 'select-many',
        selectables: [
          {
            key: 'refuseDebitsAndDepositsPartner',
            value: 'refuseDebitsAndDepositsPartner',
            conflicts: [],
            type: 'radio',
            options: {
              checked: true,
            },
            expandable: {
              fieldGroupId: 'refuseDebitsAndDepositsPartnerExpandable',
              fieldDefinitions: [
                {
                  type: 'date',
                  name: 'refuseDebitsAndDepositsPartnerDeadline',
                  options: {
                    type: 'date',
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
                {
                  type: 'select-one',
                  name: 'toggleIncludeAllrefuseDebitsAndDepositsPartner',
                  options: {
                    type: 'select-one',
                    selectables: [
                      {
                        key: 'includeAllrefuseDebitsAndDepositsPartner',
                        value: 'includeAllrefuseDebitsAndDepositsPartner',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                      {
                        key: 'certainrefuseDebitsAndDepositsPartner',
                        value: 'certainrefuseDebitsAndDepositsPartner',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: {
                          fieldGroupId:
                            'certainrefuseDebitsAndDepositsPartnerGroup',
                          fieldDefinitions: [
                            {
                              type: 'select-one',
                              name: 'blackOrWhiteListrefuseDebitsAndDepositsPartner',
                              options: {
                                type: 'select-one',
                                selectables: [
                                  {
                                    key: 'blackListrefuseDebitsAndDepositsPartner',
                                    value:
                                      'blackListrefuseDebitsAndDepositsPartner',
                                    conflicts: null,
                                    type: 'radio',
                                    options: null,
                                    expandable: null,
                                  },
                                  {
                                    key: 'whiteListrefuseDebitsAndDepositsPartner',
                                    value:
                                      'whiteListrefuseDebitsAndDepositsPartner',
                                    conflicts: null,
                                    type: 'radio',
                                    options: null,
                                    expandable: null,
                                  },
                                ],
                              },
                              gridCol: 12,
                              index: 99,
                              required: true,
                              hidden: false,
                            },
                            {
                              type: 'include',
                              name: 'refuseDebitsAndDepositsPartnerBlacklist',
                              options: null,
                              gridCol: 12,
                              index: 99,
                              required: true,
                              hidden: false,
                            },
                          ],
                          index: 99,
                        },
                      },
                    ],
                    defaultSelection:
                      'includeAllrefuseDebitsAndDepositsPartner',
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
        ],
        showHeader: true,
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
    {
      type: 'select-many',
      name: 'refuseStandingOrdersToggle',
      options: {
        type: 'select-many',
        selectables: [
          {
            key: 'refuseStandingOrders',
            value: 'refuseStandingOrders',
            conflicts: [],
            type: 'radio',
            options: {
              checked: true,
            },
            expandable: {
              fieldGroupId: 'refuseStandingOrdersExpandable',
              fieldDefinitions: [
                {
                  type: 'date',
                  name: 'refuseStandingOrdersDeadline',
                  options: {
                    type: 'date',
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
                {
                  type: 'select-one',
                  name: 'toggleIncludeAllrefuseStandingOrders',
                  options: {
                    type: 'select-one',
                    selectables: [
                      {
                        key: 'includeAllrefuseStandingOrders',
                        value: 'includeAllrefuseStandingOrders',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                      {
                        key: 'certainrefuseStandingOrders',
                        value: 'certainrefuseStandingOrders',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: {
                          fieldGroupId: 'certainrefuseStandingOrdersGroup',
                          fieldDefinitions: [
                            {
                              type: 'select-one',
                              name: 'blackOrWhiteListrefuseStandingOrders',
                              options: {
                                type: 'select-one',
                                selectables: [
                                  {
                                    key: 'blackListrefuseStandingOrders',
                                    value: 'blackListrefuseStandingOrders',
                                    conflicts: null,
                                    type: 'radio',
                                    options: null,
                                    expandable: null,
                                  },
                                  {
                                    key: 'whiteListrefuseStandingOrders',
                                    value: 'whiteListrefuseStandingOrders',
                                    conflicts: null,
                                    type: 'radio',
                                    options: null,
                                    expandable: null,
                                  },
                                ],
                              },
                              gridCol: 12,
                              index: 99,
                              required: true,
                              hidden: false,
                            },
                            {
                              type: 'include',
                              name: 'refuseStandingOrdersBlacklist',
                              options: null,
                              gridCol: 12,
                              index: 99,
                              required: true,
                              hidden: false,
                            },
                          ],
                          index: 99,
                        },
                      },
                    ],
                    defaultSelection: 'includeAllrefuseStandingOrders',
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
        ],
        showHeader: true,
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
    {
      type: 'select-many',
      name: 'transferBalanceToggle',
      options: {
        type: 'select-many',
        selectables: [
          {
            key: 'transferBalance',
            value: 'transferBalance',
            conflicts: [],
            type: 'radio',
            options: {
              checked: true,
            },
            expandable: {
              fieldGroupId: 'transferBalanceExpandableGroup',
              fieldDefinitions: [
                {
                  type: 'date',
                  name: 'transferBalanceDeadline',
                  options: {
                    type: 'date',
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
        ],
        showHeader: true,
        showSubHeader: true,
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
    {
      type: 'select-many',
      name: 'closeAccountToggle',
      options: {
        type: 'select-many',
        selectables: [
          {
            key: 'closeAccount',
            value: 'closeAccount',
            conflicts: [],
            type: 'radio',
            options: {
              checked: true,
            },
            expandable: {
              fieldGroupId: 'closeAccountExpandable',
              fieldDefinitions: [
                {
                  type: 'date',
                  name: 'accountCloseDeadline',
                  options: {
                    type: 'date',
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
        ],
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
  ],
  index: 99,
};
